import { PropsWithChildren } from 'react';
import { useMatch } from 'react-router-dom';

import { useConfig } from '../../../hooks/useConfig/useConfig';
import { useGetMenu } from '../../../hooks/useGetMenu/useGetMenu';
import { useLogoImage } from '../../../hooks/useLogoImage/useLogoImage';
import { useShowHeaderInAuth } from '../../../hooks/useShowHeaderInAuth/useShowHeaderInAuth';
import DumbHeaderSection from './HeaderSection.dumb';

/* -------------------------------- Component ------------------------------- */

/**
 * HeaderSection
 *
 * @param props HeaderSectionI
 * @returns JSX.Element
 */
const HeaderSection = ({ children }: PropsWithChildren) => {
    const showHeader = useShowHeaderInAuth();
    const {
        device: {
            web: { siteType },
        },
        page: {
            search: { enabled },
        },
    } = useConfig();

    // For controlling header styles that need to know if the search from is open or shut
    // The search form is always open when user is on the search page
    const match = useMatch({ path: '/search', end: false });

    const isMicrosite = siteType === 'microsite';

    const logo = useLogoImage(200, 40);

    const menuItems = useGetMenu(isMicrosite);

    return showHeader && siteType === 'site' ? (
        <DumbHeaderSection
            logo={logo}
            initialSearchState={Boolean(match)}
            showSearchField={enabled}
            isMicrosite={isMicrosite}
            menuItems={menuItems}
        >
            {children}
        </DumbHeaderSection>
    ) : (
        children
    );
};

/* --------------------------------- Export --------------------------------- */

export default HeaderSection;
